import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploadedFilesDirective, FilesDirective } from './files.directive';
import { UploaderComponent } from './uploader.component';
/**
 * NgModule definition for the Uploader component.
 */
export class UploaderModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [
        UploaderComponent,
        UploadedFilesDirective,
        FilesDirective
    ],
    exports: [
        UploaderComponent,
        UploadedFilesDirective,
        FilesDirective
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function UploaderModule_tsickle_Closure_declarations() {
/** @type {?} */
UploaderModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
UploaderModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
